import { Box, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledArticleGroupDetail = styled(Box)`
  .title-article-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flex-row-8 {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .pointer {
    cursor: pointer;
  }

  .fit-content-button {
    min-width: fit-content !important;
  }

  .body {
    margin-top: 24px;
  }

  .footer-card {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    width: fill-available;
    position: absolute;
    bottom: 0;
    background-color: ${COLOR.white[100]};
    padding: 16px 32px 32px 32px;

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12px;
      min-width: 128px;
    }
  }
`;

export const StyledDialog = styled(Dialog)`
  width: 100%;
  .title {
    font-size: 24px;
    font-weight: 700;
    line-height: 28px;
    padding: 24px 24px 0 24px;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 500px;
  }

  .label-input {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;

    span {
      color: ${COLOR.error.base};
    }
  }

  .action {
    display: flex;
    justify-content: flex-end;
    gap: 16px;

    .button {
      min-width: 120px;
    }
  }

  .text-area {
    padding: 8.5px 14px;
    border-radius: 24px;
    border: 1px solid ${COLOR.border.default};

    :hover {
      border-color: ${COLOR.border.hover};
    }
  }

  .error {
    border-color: ${COLOR.error.base};
    margin-bottom: 2px;

    :hover {
      border-color: ${COLOR.error.base};
    }
  }

  .error-text {
    margin-left: 15px;
  }
`;
